<mat-toolbar color="accent" class="d-flex justify-content-between">
    <button mat-icon-button aria-label="close menu" (click)="layoutService.toggleNotifications()">
        <mat-icon class="white">chevron_right</mat-icon>
    </button>
    <span class="white">Notifications</span>
</mat-toolbar>

@if (activeNotifications.length) {
    <button mat-button class="notif-dismiss-all" (click)="dismissAll()">
        <mat-icon>close</mat-icon>
        Dismiss All
    </button>
}

<div class="notifications-div" #notificationsList>
    @if (!activeNotifications.length) {
        <div class="notif-empty" animate.enter="slide-in">
            <div class="notif-empty__icon-wrap">
                <mat-icon class="notif-empty__icon">inbox</mat-icon>
            </div>
            <p class="notif-empty__title">You're all caught up</p>
            <p class="notif-empty__body">New notifications will show up here.</p>
        </div>
    }

    @if (attention.length) {
        <div #attentionSection>
            <p class="notif-section-label">Needs attention</p>
            @for (notification of attention; track notification.ID) {
                <notification-row
                    [notification]="notification"
                    (dismiss)="dismissNotification(notification)"
                    (action)="notificationToggle(notification)"
                    animate.enter="slide-in"
                    animate.leave="slide-out" />
            }
        </div>
    }

    @if (others.length) {
        @if (attention.length) {
            <p class="notif-section-label notif-section-label--secondary">All notifications</p>
        }
        @for (notification of shownOthers; track notification.ID) {
            <notification-row
                [notification]="notification"
                (dismiss)="dismissNotification(notification)"
                (action)="notificationToggle(notification)"
                animate.enter="slide-in"
                animate.leave="slide-out" />
        }
        @if (others.length > visibleCount) {
            <button mat-button class="notif-show-more" (click)="showMore()">Show {{ remainingCount }} more</button>
        }
    }
</div>
